import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import Hero from '../components/app-growth/Hero';
import LogoStrip from '../components/app-growth/LogoStrip';
import Pain from '../components/app-growth/Pain';
import Solution from '../components/app-growth/Solution';
import Why from '../components/app-growth/Why';
import Services from '../components/app-growth/Services';
import Engagement from '../components/app-growth/Engagement';
import Proof from '../components/app-growth/Proof';
import Process from '../components/app-growth/Process';
import LeadForm from '../components/app-growth/LeadForm';
import { organization, breadcrumb, wrap, SITE_URL } from '../components/seo/schemas';
import { Toaster } from '../components/ui/toaster';

const PAGE_URL = `${SITE_URL}/app-growth`;

const structuredData = wrap([
  organization,
  breadcrumb([
    { name: 'Home', url: SITE_URL },
    { name: 'App Growth', url: PAGE_URL },
  ]),
  {
    '@type': 'Service',
    '@id': `${PAGE_URL}#service`,
    name: 'App Growth & Performance Marketing',
    description:
      'Upscale helps Norwegian app companies grow users and revenue with performance marketing, app-store optimization, creative testing, tracking, and subscription growth.',
    provider: { '@id': `${SITE_URL}/#organization` },
    areaServed: ['Norway', 'Nordics', 'Europe'],
    serviceType: 'App Growth Marketing',
    url: PAGE_URL,
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'App Growth Services',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'App Growth Audit' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Performance Marketing for Apps' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Subscription & Revenue Growth' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'App Store & Creative Optimization' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Tracking, Analytics & Growth Reporting' } },
      ],
    },
  },
  {
    '@type': 'WebPage',
    '@id': `${PAGE_URL}#webpage`,
    url: PAGE_URL,
    name: 'App Growth & Performance Marketing Agency Norway | Upscale',
    description:
      'Upscale helps Norwegian app companies grow users and revenue with performance marketing, app-store optimization, creative testing, tracking, and subscription growth.',
    inLanguage: 'en',
    isPartOf: { '@type': 'WebSite', name: 'Upscale', url: SITE_URL },
    primaryImageOfPage: `${SITE_URL}/og-image.png`,
  },
]);

const AppGrowthPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="App Growth & Performance Marketing Agency Norway | Upscale"
        description="Upscale helps Norwegian app companies grow users and revenue with performance marketing, app-store optimization, creative testing, tracking, and subscription growth."
        keywords="app growth agency Norway, performance marketing for apps, mobile app user acquisition, app marketing agency Norway, Apple Search Ads agency Norway, Google App Campaigns agency, Meta Ads for apps, subscription app growth, app revenue growth, app store conversion optimization"
        canonicalUrl={PAGE_URL}
        ogTitle="App Growth & Performance Marketing for Norwegian app companies"
        ogDescription="More users, revenue, and repeat growth — with a practical growth system built around data, testing, and commercial outcomes."
        structuredData={structuredData}
      />
      <Navbar />
      <Hero />
      <LogoStrip />
      <Pain />
      <Solution />
      <Why />
      <Services />
      <Engagement />
      <Proof />
      <Process />
      <LeadForm />
      <Footer />
      <Toaster />
    </div>
  );
};

export default AppGrowthPage;
